<template>
  <b-form-input
    v-if="!multiline"
    :placeholder="label"
    :disabled="disabled"
    :value="fromValue(value)"
    :state="error ? false : null"
    @keydown.enter="$emit('input', fromValue($event.target.value))"
    @blur="$emit('input', fromValue($event.target.value))"><!---->
  </b-form-input>
  <b-form-textarea
    v-else="multiline"
    :placeholder="label"
    :disabled="disabled"
    :value="fromValue(value)"
    :state="error ? false : null"
    rows="3"
    max-rows="8"
    trim
    no-resize
    @blur="$emit('input', fromValue($event.target.value))">
  </b-form-textarea>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import StringFieldMixin from 'vue-forms/mixins/StringFieldMixin';

export default {
  mixins: [ FormFieldMixin, StringFieldMixin ],
};
</script>
